import DatosPersona from './form/DatosPersona';
import Direccion from './form/Direccion';

const PersonaFisica = ({ className, isDisabled }: { readonly className?: string; readonly isDisabled?: boolean }) => (
	<>
		<DatosPersona isDisabled={isDisabled} title="Datos de la persona" className={`u-mt-16 ${className ?? ''}`} />
		<Direccion isDisabled={isDisabled} title="Dirección de la persona" className="u-mt-16" />
	</>
);

export default PersonaFisica;
